import { createStore as reduxCreateStore, combineReducers } from 'redux'
import { reducer as reduxFormReducer } from 'redux-form'

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form"
})

const createStore = () => reduxCreateStore(reducer)
export default createStore
